import { Keypair } from '@solana/web3.js';
import { base64ToBytes } from '../encoding';

export interface SolanaKeyPair extends Keypair {}

export const generateSolanaKeyPair = async (): Promise<SolanaKeyPair> => {
  try {
    const keypair = Keypair.generate();
    
    return keypair;
  } catch (error) {
    throw new Error(`Failed to generate Solana key pair: ${error}`);
  }
};

export const createKeypairFromPrivateKey = (privateKey: string): Keypair => {
  try {
    const secretKey = base64ToBytes(privateKey);
    return Keypair.fromSecretKey(secretKey);
  } catch (error) {
    throw new Error(`Failed to create keypair from private key: ${error}`);
  }
};